export default function goback(url) {
    if (window.history.length > 1) {
        // 执行后退
        window.history.back();
    } else {
        // 否则跳转到指定的URL
        window.location.href = url;
    }
}